export const enum StepsEnum {
	START = "start",
	REQUIREMENTS = "requirements",
	INIZIAMO = "iniziamo",
	LA_TUA_AZIENDA = "la-tua-azienda",
	IDENTIFICAZIONE = "identificazione",
	SERVIZI = "servizi",
	PAGAMENTI = "pagamenti",
	VERIFICA_IDENTITA = "verifica-identita",
	FIRMA_CONTRATTO = "firma-contratto",
	WELCOME = "welcome",
	PROCESSO_TERMINATO = "processo-terminato",
}

export enum SubStepsEnum {
	ANAGRAFICA = "anagrafica",
	ANAGRAFICA_TITOLARE = "anagrafica-titolare",
	CARICHE_PUBBLICHE = "cariche-pubbliche",
	CARICHE_PUBBLICHE_TITOLARE = "cariche-pubbliche-titolare",
	VERIFICA_IDENTITA = "verifica-identita",
	CREAZIONE_PROFILO = "creazione-profilo",
	CODICE_ATTIVAZIONE = "codice-attivazione",
	CERCA_IMPRESA = "cerca-impresa",
	PRESENTA_AZIENDA = "presenta_azienda",
	DATI_AZIENDALI = "dati-aziendali",
	INDIRIZZI_CONTATTI = "indirizzi-contatti",
	BILANCIO_IMPRESA = "bilancio-impresa",
	DETTAGLI_SOCIETA = "dettagli-societa",
	LEGALE_RAPPRESENTANTE = "legale-rappresentante",
	TITOLARI_EFFETTIVI = "titolari-effettivi",
	CONTO_PAGAMENTO = "conto-pagamento",
	CONVENZIONI_POS = "convenzioni-pos",
	SERVIZI_FINANZIARI = "servizi-finanziari",
	MANDATO_ADDEBITO_DIRETTO = "mandato-addebito-diretto",
	FIRMA = "firma",
	NEXT_STEP = "next-step",
	LAST_SUBSTEP = "last-substep",
}

export interface StepStructure {
	step: StepsEnum;
	subStep: SubStepsEnum;
}
